<template>
    <header class="header">
        <div class="head-box clear">
            <div class="head-info">
                <a href="/">返回首页</a>
                <router-link :to="{name:'pageList'}" title="网站方案" class="cur">网站方案</router-link>
                <router-link :to="{name:'zcool'}" title="牛商图库">牛商图库</router-link>
                <router-link :to="{name:'certificate'}" title="SSL证书">SSL证书</router-link>
                <a href="/product_index.html" class="cur" target="_blank">营销市场</a>
                <a href="http://help.web724.cn" class="cur" target="_blank">帮助中心</a>
                <router-link :to="{name:'console'}" class="cur">控制台</router-link>
                <div class="user-info">
                    <figure class="photo-main" v-if="userInfo.icon">
                        <img :src="userInfo.icon" />
                    </figure>
                    <figure class="photo-main" v-if="!userInfo.icon">
                        <i class="iconfont icon-renyuan"></i>
                    </figure>
                    <div class="user-con">
                        <div class="user-avatar">
                            <figure class="photo-main2" v-if="userInfo.icon">
                                <img :src="userInfo.icon" />
                            </figure>
                            <figure class="photo-main2" v-if="!userInfo.icon">
                                <i class="iconfont icon-renyuan"></i>
                            </figure>
                            <span>{{userInfo.moblie}}</span>
                        </div>
                        <ul>
                            <li>
                                <router-link :to="{name:'companyInfo'}">
                                    <i class="iconfont icon-geren"></i>企业信息
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{name:'accountInfo'}">
                                    <i class="iconfont icon-anquan2"></i>账号信息
                                </router-link>
                            </li>
                            <li><router-link :to="{name:'certify'}"><i class="iconfont icon-anquan1"></i>实名认证</router-link></li>
                        </ul>
                        <div class="user-exit" @click="logoutFn">退出系统</div>
                    </div>
                </div>

                <!-- <a href="javascript:;" class="exit-a" @click="logoutFn">退出</a> -->
            </div>
        </div>
        <yq-dialog-hint :showDialog.sync="showDialog" :config="dialogConfig" @defined="definedBack"></yq-dialog-hint>
    </header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import mixinDialog from '@/mixins/mixinsDialog'

export default {
    name: 'headMain',
    data () {
        return {}
    },
    mixins: [mixinDialog],
    computed: {
        ...mapGetters('user', ['userInfo']),
        ...mapGetters('templateConfig', ['filterCombo']),
    },
    methods: {
        ...mapActions('user', ['logoutUser', 'getUpdTipStatus', 'getFrontUserInfo']),
        //注销
        logoutFn () {
            this.openErrDialog('ask', '操作信息提示', 'logoutUser', '', '确认要退出系统吗？', '确定')
        }
    }
}

</script>

<style lang="scss" scoped>
.header {
    position: relative;
    .head-box {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 56px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 1px 2px 0px rgba(222, 224, 243, 1);
        z-index: 100;
    }
    .head-info {
        margin: 0px 40px 0 0;
        line-height: 14px;
        height: 56px;
        /*height: 100%;*/
        display: flex;
        align-items: center;
        justify-content: flex-end;
        order: 10;

        a {
            display: inline-block;
            padding: 0 20px;
            font-size: 14px;
            color: #373d45;

            &.cur {
                cursor: pointer;
                border-right: 2px solid #fff;
                // &:hover {
                // 	color: $colorA;
                // }
            }
            &.exit-a {
                border-left: 2px solid #fff;
            }
        }
        .account-info {
            display: flex;
            align-items: center;
            span {
                padding: 0;
                line-height: 20px;
                i {
                    /*color: #383a4c;*/
                    color: #9a9898;
                }
                .font-color {
                    color: rgb(255, 188, 31);
                    margin-right: 5px;
                }
            }
        }
    }
    .photo-main {
        display: inline-block;
        width: 36px;
        height: 36px;
        vertical-align: -10px;
        border-radius: 50%;
        overflow: hidden;
        i {
            font-size: 36px;
            line-height: 36px;
            color: #8e9bcd;
        }
        cursor: pointer;
        img {
            display: block;
            width: 100%;
            height: 100%;
        }
    }
}

.i-slogn2 {
    display: inline-block;
    margin: 0px 0 0 25px;
    font-size: 20px;
    color: #fff;
    line-height: 20px;
}
.user-info {
    height: 56px;
    position: relative;
    padding-top: 10px;
    &:hover {
        .user-con {
            display: block;
        }
    }
}
.user-con {
    display: none;
    position: absolute;
    top: 56px;
    right: -40px;
    width: 190px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 6px -1px rgba(142, 155, 205, 0.44);
    border-radius: 3px;
    padding: 10px 0 0 0;
    font-size: 14px;
    line-height: 36px;
    color: #555e6a;
    ul {
        margin-bottom: 10px;
    }
    li {
        padding-left: 22px;
        height: 36px;
        font-size: 14px;
        line-height: 36px;
        cursor: pointer;
        i {
            color: #c6cde6;
            margin-right: 10px;
        }
    }
}
.user-avatar {
    padding-left: 14px;
    display: flex;
    margin-bottom: 10px;
    span {
        display: block;
    }
    .photo-main2 {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        overflow: hidden;
        margin-top: 2px;
        margin-right: 8px;
        vertical-align: middle;
        img {
            width: 100%;
            display: block;
        }
        i {
            font-size: 36px;
            line-height: 36px;
            color: #8e9bcd;
        }
    }
}
.user-exit {
    padding-left: 22px;
    border-top: 1px solid #e8eaf0;
    height: 39px;
    line-height: 39px;
    cursor: pointer;
}
</style>
